import { createContext, type ReactNode, useContext } from 'react';

/**
 * Opts charts inside the provider into `PlotTooltip`'s portalled render mode
 * (`position: fixed` in `document.body`) instead of the default inline
 * `position: absolute`. Needed where a chart ancestor clips overflow or sits
 * below the rest of the app in stacking order — currently only the AI
 * assistant chart preview drawer.
 *
 * Uses a context rather than a per-chart prop because charts go through
 * several wrapper layers; this opts in the entire subtree (including
 * descendants reached via `React.createPortal`) without prop-drilling.
 */
const PlotTooltipPortalContext = createContext(false);

export const PlotTooltipPortalProvider = ({
  children,
}: {
  children: ReactNode;
}) => (
  <PlotTooltipPortalContext.Provider value={true}>
    {children}
  </PlotTooltipPortalContext.Provider>
);

export const usePlotTooltipPortalEnabled = () =>
  useContext(PlotTooltipPortalContext);
